import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputMask from 'react-input-mask'
import MaterialInputable from './MaterialInputable'

const styles = theme => ({
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
})

class MaterialPhone extends React.Component {
	constructor(props) {
		super(props)

		this.beforeMaskedValueChange = this.beforeMaskedValueChange.bind(this)
	}

	beforeMaskedValueChange(newState, oldState, userInput) {
		var { value } = newState
		var selection = newState.selection
		var cursorPosition = selection ? selection.start : null

		if (value.endsWith(') ') || value.endsWith(' (')) {
			if (cursorPosition === value.length) {
				cursorPosition = cursorPosition - 2
				selection = { start: cursorPosition, end: cursorPosition }
			}
			value = value.slice(0, -1)
		}

		if (value.endsWith('-') || value.endsWith(' ') || value.endsWith('(') || value.endsWith(')')) {
			if (cursorPosition === value.length) {
				cursorPosition--
				selection = { start: cursorPosition, end: cursorPosition }
			}
			value = value.slice(0, -1)
		}

		return {
			value,
			selection
		}
	}

	render() {
		const { classes, mask, extensionMask, name, InputLabelProps, label, value, InputProps, placeholder, errorMessage, onChange, onBlur, onKeyDown, disabled, extension, required, error } = this.props

		return (
			<InputMask
				mask={extension ? extensionMask : mask}
				maskChar={null}
				id={name}
				value={value}
				onChange={onChange}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				className={classes.textField}
				disabled={disabled}
				beforeMaskedValueChange={this.beforeMaskedValueChange}
			>
				{() =>
					<MaterialInputable
						type="tel"
						name={name}
						label={label} 
						placeholder={placeholder}
						errorMessage={errorMessage}
						required={required}
						InputLabelProps={InputLabelProps}
						error={error}
						fullWidth
						InputProps={InputProps}
						disabled={disabled}
					/>
				}
			</InputMask>
		)
	}
}

MaterialPhone.propTypes = {
	classes: PropTypes.object,
	name: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]).isRequired,
	placeholder: PropTypes.string,
	InputProps: PropTypes.object,
	errorMessage: PropTypes.string,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	error: PropTypes.bool,
	extension: PropTypes.bool,
	mask: PropTypes.string,
	extensionMask: PropTypes.string,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	onKeyDown: PropTypes.func, 
	InputLabelProps: PropTypes.object
}

MaterialPhone.defaultProps = {
	value: '',
	label: '',
	placeholder: '',
	errorMessage: '',
	disabled: false,
	required: false,
	error: false,
	extension: false,
	mask: "(999) 999-9999",
	extensionMask: "(999) 999-9999 99999"
}

export default withStyles(styles)(MaterialPhone)


// WEBPACK FOOTER //
// ./src/components/MaterialPhone.js